import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const BillingSystem = () => {
    const display = () => {
        return window.innerWidth > 500;
    };

    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsBillingSystem" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/BillingSystem/BillingSystem.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                        
                        <ProjectCarouselButtons tag="BillingSystem" />
                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">Billing System</p>
                            <p className="Project--info--subheading">Desktop Application</p>
                            <p className="Project--info--subheading">Built with Java Swing</p>

                            {display() ? (
                                <>
                                    <p className="Project--info--Para">
                                        A desktop billing system designed with Java Swing, offering robust product management, billing generation, and secure access control.
                                    </p>
                                    <p className="Project--info--Para">
                                        It integrates MySQL for data persistence and features GUI-based workflows for inventory updates, invoice creation, and user login authentication.
                                    </p>
                                </>
                            ) : (
                                <p className="Project--info--Para">
                                    Java Swing-based billing app with product tracking, invoice generation, and MySQL-powered database integration.
                                </p>
                            )}
                        </div>

                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/Billing-System" target='__blank'>GitHub</a>
                        </div>

                        <div className="Project--info--tech">
                            <p>Java</p>
                            <p>Java Swing</p>
                            <p>MySQL</p>
                            <p>Maven</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BillingSystem;